/**
 * Timetastic
 * Header component
 */
import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

// Components
import Logo from "src/components/logo"
import Nav from "src/components/nav"

// Styles
import "./header.scss"

// JSX
const Header = ({ isHomepage }) => {
  return (
    <header className="c-header">
      <div className="u-inner u-inner--full c-header__inner">
        <div className="c-header__flex">
          {isHomepage && (
            <a className="c-header__logo-link is-home" href="/">
              <Logo />
            </a>
          )}
          {!isHomepage && (
            <Link className="c-header__logo-link" to="/">
              <Logo />
            </Link>
          )}
          <Nav />
        </div>
      </div>
    </header>
  )
}

Header.propTypes = {
  isHomepage: PropTypes.bool,
}

Header.defaultProps = {
  isHomepage: false,
}

export default Header
